export default __webpack_public_path__ + "static/media/explore-desktop-5.d0ef8949.png";